import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import CustomRadioButton from "../../components/common/Custom/CustomRadioButton";

interface TemplatePageProps {
  values: any;
  handleChange: (e: React.ChangeEvent<any>) => void;
  templateAttributes: string[];
}

function convertToTitle(str: string) {
  return str
    .split(/(?=[A-Z])/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

const TemplatePage: React.FC<TemplatePageProps> = ({
  values,
  handleChange,
  templateAttributes,
}) => {
  const labelSpan = 3;
  const fieldSpan = 9;

  const exclude = new Set([
    "id",
    "emailTemplate",
    "emailTemplateId",
    "attachPDFForm",
  ]);

  const attributes = templateAttributes.filter((item) => !exclude.has(item));

  const renderRadioButton = (index: number, offset: number) => {
    const currentIndex = index + offset;
    return (
      currentIndex < attributes.length && (
        <>
          <Form.Label column xs={3} lg={3} xl={3}>
            {convertToTitle(attributes[currentIndex])}
          </Form.Label>
          <Col xs={3} lg={3} xl={3}>
            <CustomRadioButton
              name={attributes[currentIndex]}
              handleChange={handleChange}
              values={values}
            />
          </Col>
        </>
      )
    );
  };

  return (
    <>
      {attributes.map((_, index: number) => {
        const pairIndex = index * 2;
        if (pairIndex >= attributes.length) return null;

        return (
          <Form.Group as={Row} controlId="sendto" key={pairIndex}>
            <Form.Label column xs={6} lg={6} xl={labelSpan}>
              {index === 0 && "Send to"}
            </Form.Label>

            <Col xs={6} lg={6} xl={fieldSpan}>
              <Form.Group as={Row} controlId={`sendto-${pairIndex}`}>
                {renderRadioButton(pairIndex, 0)}
                {renderRadioButton(pairIndex, 1)}
              </Form.Group>
            </Col>
          </Form.Group>
        );
      })}
    </>
  );
};

export default TemplatePage;
